// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__menuContainer___d4JWL {
    position: absolute;
    background-color: #ffffff;
    width: 300px;
    border: 0.5px solid lightgrey;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    top: 55px;
    right: 20px;
}

.style__infoContainer___X8ttA {
    margin-top: 20px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
}

.style__nameContainer___WsDZW {
    display: flex;
    flex-direction: row;
    align-self: center;
}

.style__name___dAbFK {
    /*margin-top: 10px;*/
    font-weight: bold;
}

.style__email___RlWwx {
    margin-top: 10px;
    text-align: left;
    margin-left: 20px;
    /*font-weight: bold;*/
}

.style__note___CAy2w {
    color: #8d8d8d;
    font-size: 13px;
    flex: 1;
    margin-left: 4px;
    text-align: left;
}

.style__noteContainer___xOTc7 {
    display: flex;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 0 12px;
    flex-direction: row;
    align-items: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/components/ProfileMenu/SettingsMenu/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,6BAA6B;IAC7B,wCAAwC;IACxC,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,OAAO;IACP,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".menuContainer {\n    position: absolute;\n    background-color: #ffffff;\n    width: 300px;\n    border: 0.5px solid lightgrey;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    border-radius: 12px;\n    top: 55px;\n    right: 20px;\n}\n\n.infoContainer {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.nameContainer {\n    display: flex;\n    flex-direction: row;\n    align-self: center;\n}\n\n.name {\n    /*margin-top: 10px;*/\n    font-weight: bold;\n}\n\n.email {\n    margin-top: 10px;\n    text-align: left;\n    margin-left: 20px;\n    /*font-weight: bold;*/\n}\n\n.note {\n    color: #8d8d8d;\n    font-size: 13px;\n    flex: 1;\n    margin-left: 4px;\n    text-align: left;\n}\n\n.noteContainer {\n    display: flex;\n    margin-top: 12px;\n    margin-bottom: 12px;\n    padding: 0 12px;\n    flex-direction: row;\n    align-items: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuContainer": `style__menuContainer___d4JWL`,
	"infoContainer": `style__infoContainer___X8ttA`,
	"nameContainer": `style__nameContainer___WsDZW`,
	"name": `style__name___dAbFK`,
	"email": `style__email___RlWwx`,
	"note": `style__note___CAy2w`,
	"noteContainer": `style__noteContainer___xOTc7`
};
export default ___CSS_LOADER_EXPORT___;
